// src/services/api.js
import axios from 'axios';
import { useAuthStore } from '@/store/auth';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // Ini akan menjadi 'https://api.bank.nazrif.com'
  headers: {
    'Content-Type': 'application/json'
  }
});


apiClient.interceptors.request.use(config => {
  const authStore = useAuthStore();
  const token = authStore.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

export default {
  login(credentials) {
    const params = new URLSearchParams();
    params.append('username', credentials.email);
    params.append('password', credentials.password);
    
    // HAPUS /api/ dari sini
    return apiClient.post('/token', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  },

  getAllUsers() {
  // Endpoint ini akan mengembalikan daftar semua pengguna
  // Kita bisa tambahkan parameter paginasi (skip, limit) nanti
  return apiClient.get('/admin/all-users');
},

  getAccounts() {
    // HAPUS /api/ dari sini
    return apiClient.get('/accounts/');
  },

  // Fungsi untuk CS/Admin membuat user baru
    createUser(userData) {
    return apiClient.post('/users/', userData);
    },

    // Fungsi untuk registrasi publik
    register(userData) {
    return apiClient.post('/register/', userData);
    },
    
    createAccount(accountData) {
      return apiClient.post('/accounts/', accountData);
    },

  transferFunds(transferData) {
    // HAPUS /api/ dari sini
    return apiClient.post('/transactions/transfer', transferData);
  },

  getTransactionsForAccount(accountId) {
    // HAPUS /api/ dari sini
    return apiClient.get(`/transactions/history/${accountId}`);
  },
  
  deposit(accountId, amount) {
    // HAPUS /api/ dari sini
    return apiClient.post(`/accounts/${accountId}/deposit`, { amount });
  },

  findUserByEmail(email) {
    // HAPUS /api/ dan /admin/ dari sini
    return apiClient.get('/admin/find-user', { params: { email } });
  },
  
  getPendingUsers() {
  return apiClient.get('/admin/pending-users');
  },

  updateUserStatus(userId, newStatus) {
  return apiClient.put(`/admin/users/${userId}/status`, { new_status: newStatus });
  },
  
  tellerDeposit(depositData) {
  // depositData: { destination_account_number, amount }
  return apiClient.post('/teller/deposit', depositData);
  },
  findAccountByNumber(accountNumber) {
  return apiClient.get('/accounts/find-by-number', {
    params: { account_number: accountNumber }
  });
 },
  applyForLoan(loanData) {
  // loanData: { account_id, amount, purpose }
  return apiClient.post('/loans/', loanData);
},
getMyLoans() {
  return apiClient.get('/loans/my-loans');
},
getLoansForVerification() {
  return apiClient.get('/loans/pending-verification');
},
verifyLoan(loanId, newStatus) {
  return apiClient.put(`/loans/${loanId}/verify`, { new_status: newStatus });
},
getLoansForApproval() {
  return apiClient.get('/loans/pending-approval');
},
approveLoan(loanId, newStatus) {
  return apiClient.put(`/loans/${loanId}/approve`, { new_status: newStatus });
},
tellerWithdrawal(withdrawalData) {
  // withdrawalData: { source_account_number, amount }
  return apiClient.post('/teller/withdraw', withdrawalData);
},
getBankCash() {
  return apiClient.get('/admin/bank-cash');
},
getTransactionCodes() {
  return apiClient.get('/master-data/transaction-codes/');
},

createTransactionCode(codeData) {
  return apiClient.post('/master-data/transaction-codes/', codeData);
},

updateTransactionCode(codeId, codeData) {
  return apiClient.put(`/master-data/transaction-codes/${codeId}`, codeData);
},

deleteTransactionCode(codeId) {
  return apiClient.delete(`/master-data/transaction-codes/${codeId}`);
},
getPendingTransactions() {
  return apiClient.get('/supervisor/pending-transactions');
},

approveTransaction(transactionId) {
  // Kita tidak perlu mengirim body, cukup panggil endpoint approve
  return apiClient.put(`/supervisor/transactions/${transactionId}/approve`);
},
getGeneralLedger(page = 1, limit = 10, search = '') {
  const skip = (page - 1) * limit;
  return apiClient.get('/admin/general-ledger', { params: { skip, limit, search } });
},
getDashboardSummary() {
  return apiClient.get('/dashboard/summary');
},
repayLoan(loanId, repaymentData) {
  // repaymentData: { from_account_id, amount }
  return apiClient.post(`/loans/${loanId}/repay`, repaymentData);
},
getPendingAccounts() {
  return apiClient.get('/admin/pending-accounts');
},
getLoanDetails(loanId) {
  return apiClient.get(`/loans/${loanId}`);
},
adminCreateAccount(accountData) {
  // accountData: { owner_id, account_type }
  return apiClient.post('/admin/create-account', accountData);
},
updateAccountStatus(accountId, newStatus) {
  return apiClient.put(`/admin/accounts/${accountId}/status`, { new_status: newStatus });
},
downloadReceipt(transactionId) {
  return apiClient.get(`/teller/transactions/${transactionId}/receipt`, {
    responseType: 'blob', // Penting untuk file
  });
},
downloadStatement(accountId) {
  return apiClient.get(`/accounts/${accountId}/statement`, {
    responseType: 'blob', // Penting agar Axios menangani respons sebagai file
  });
},

rejectTransaction(transactionId) {
  return apiClient.put(`/supervisor/transactions/${transactionId}/reject`);
},

  getUserProfile() {
  return apiClient.get('/users/me');
  } 
};

